/**
 * @author Gananath Athukorala
 * @version 0.1
 */

import React, { useState,useEffect } from "react";
import api from "../../services/AuthApi";
import { RequestErrorHandeling } from "../../errorHandeling/RequestErrorHandeling";
import UserAccountModal from "./UserAccountModal";
import { JSEncrypt } from "jsencrypt"
import base64url from "base64url"

const encrypt = new JSEncrypt()
const publicKey = `
    -----BEGIN PUBLIC KEY-----
    MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAsy+1EQqpdOCQM4OaAflU9rQZGzo8TexVbkez7q67egtwZT5BCG5bClBk95paacF3HgMwh4se6ZhttdkiJfr/gGagOqP2FTZKqEaz7d24FSpYyKUVdgZ7eDNgiBbkWVZi83dGqlMGM2wmES3Q614P3JN+BiZ5srvc4q0BXnw8y40MB10KY0dONVuKrywKEKoHCfjIvKJNH3FyYaCwslQC4m94ErDr5OGbO3qPLiJzw7fRoU3WN05OZvGuYkgS0yN2KUKOp/vAyG6h1Mf+bayILTAGJRxyYdLGvL8Y/90NIFNvXtO4IHfY8HO/bymOic/gPE7XU1lHTK1EvrF55a/E3wIDAQAB
    -----END PUBLIC KEY-----`
// Assign encryptor to utilize the public key.
encrypt.setPublicKey(publicKey)

const CreateNewAccountModal = ({ open, isUpdate, setIsUpdate, onClose }) => {
  const [values, setValues] = useState({})
  const [isPrimContactValid, setIsPrimContactValid] = useState(false)
  const [isSecContactValid, setIsSecContactValid] = useState(false)
  const [passwordMatches, setPasswordMatches] = useState(false)
  const [isSubmit, setIsSubmit] = useState(false)
  const [errors, setErrors] = useState({
    cofmPassword: "",
    primContact: "",
    secContact: "",
  })

  //for success messages
  const [isSuccess, setIsSuccess] = useState(false)
  const [successMessages, setSuccessMessages] = useState([])

  //for error handling
  const [iserror, setIserror] = useState(false)
  const [iserrorShow, setIserrorShow] = useState(false)
  const [errorMessages, setErrorMessages] = useState([])

  const [orgCode, setOrgCode] = useState()

  //clear all alerts after a timeout
  useEffect(() => {
    if ((iserror || isSuccess) === true) {
      let timerId = setTimeout(() => {
        setSuccessMessages([])
        setIsSuccess(false)
        setIserror(false)
        setErrorMessages([])
        timerId = null
      }, 5000)
      return () => clearTimeout(timerId)
    }
  }, [iserror, isSuccess])

  const handleOrgChange = (event) => {
    const value = event.target.value
    setOrgCode(value)
  }

  const handleOnChange = (event) => {
    const { name, value } = event.target
    setValues({
      ...values,
      [name]: value,
    })
  }

  const handleClearData = () => {
    onClose()
    setValues({})
    setIsSuccess(false)
    setSuccessMessages([""])
    setIserror(false)
    setIserrorShow(false)
    setErrorMessages([])
    setErrors({
      cofmPassword: "",
      primContact: "",
      secContact: "",
    })
    setIsPrimContactValid(false)
    setIsSecContactValid(false)
    setPasswordMatches(false)
    setIsSubmit(false)
  }

  const checkValidatoin = (event) => {
    event.preventDefault()
    setErrors({
      cofmPassword: "",
      primContact: "",
      secContact: "",
    })
    setIsPrimContactValid(false)
    setIsSecContactValid(false)
    setPasswordMatches(false)

    const primContact = values.primContact
    const secContact = values.secContact

    if (primContact && (primContact.length < 10 || primContact.length > 20)) {
      setErrors({
        primContact: "Primary contact should be between 10 and 20 characters.",
      })
      setIsPrimContactValid(true)
    } else if (
      secContact &&
      (secContact.length < 10 || secContact.length > 20)
    ) {
      setErrors({
        secContact: "Secondary contact should be between 10 and 20 characters.",
      })
      setIsSecContactValid(true)
    } else if (primContact && primContact === secContact) {
      setErrors({
        primContact: "Primary and secondary contacts should not be equal.",
        secContact: "Primary and secondary contacts should not be equal.",
      })
      setIsPrimContactValid(true)
      setIsSecContactValid(true)
    } else if (values.password !== values.cofmPassword) {
      setErrors({ cofmPassword: "Passwords do not match" })
      setPasswordMatches(true)
    } else {
      handleCreateNewRow()
    }
  }

  const handleCreateNewRow = () => {
    const reg = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)(?=.*?[#?!@$%^&*-]).{8,}$/
    setIsUpdate(false)
    setIsSubmit(true)
    const inputPw = values.password
    // Perform our encryption based on our public key - only private key can read it!
    const encryptedNewPassword = encrypt.encrypt(inputPw)
    //Converting the encrypted password to url friendly base64URL encoded
    const urlEncodedNewPassword = base64url.toBase64(encryptedNewPassword)

    if (reg.test(inputPw)) {
      const formData = new FormData()
      const copyData = { ...values }
      copyData.password = urlEncodedNewPassword
      copyData.branchCode = null

      Object.keys(copyData).forEach((key) => {
        if (copyData[key] === "") {
          delete copyData[key]
        }
      })


      const profileData = new Blob([JSON.stringify(copyData)], {
        type: "application/json",
      })
      formData.append("profile_data", profileData)
      // Create new user config
      let postConfig = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }

      api
        .post("/users", formData, postConfig)
        .then((res) => {
          setErrorMessages([])
          setIserror(false)
          setErrorMessages([])
          setIsSuccess(true)
          setSuccessMessages([res.data?.description])
          setIsUpdate(true)
          setTimeout(() => {
            handleClearData()
          }, 3000)
        })
        .catch((error) => {
          setIsSubmit(false)
          setIsSuccess(false)
          RequestErrorHandeling(
            error,
            setIserror,
            setErrorMessages,
            setIserrorShow
          )
        })
    } else {
      setIsSubmit(false)
      setIserror(true)
      setIserrorShow(true)
      setErrorMessages([
        "Password should be minimum eight characters, at least one upper case letter, one lower case letter, one number and one special character",
      ])
    }
  }

  return (
    <UserAccountModal
      open={open}
      values={values}
      title="Create User Account"
      handleSave={checkValidatoin}
      handleOnChange={handleOnChange}
      handleClearData={handleClearData}
      isLoading={false}
      isPrimContactValid={isPrimContactValid}
      isSecContactValid={isSecContactValid}
      passwordMatches={passwordMatches}
      isSubmit={isSubmit}
      errors={errors}
      isSuccess={isSuccess}
      successMessages={successMessages}
      iserror={iserror}
      iserrorShow={iserrorShow}
      errorMessages={errorMessages}
      userRoleDisabled={false}
      userNameDisabled={false}
      visibility="block"
      orgCode={orgCode}
      handleOrgChange={handleOrgChange}
    />
  )
};

export default CreateNewAccountModal;
